import { ButtonComponent } from '@/components/commons'
import { Text } from '@/components/commons/typography/Text'
import { EditIconPen, PlusIcon } from '@/public/assets/v2/images/icons'
import { Menu } from '@mantine/core'

interface HighlightMenuProps {
  isEditing?: boolean
  onCreate: () => void
  onEdit: () => void
  onComplete: () => void
}

export const HighlightMenu = ({
  isEditing,
  onEdit,
  onCreate,
  onComplete,
}: HighlightMenuProps) => {
  if (isEditing)
    return (
      <ButtonComponent
        size="xSmall"
        label={isEditing ? 'Finish' : 'Add/Edit'}
        onClick={() => (isEditing ? onComplete() : null)}
      />
    )

  return (
    <Menu position="bottom-end" offset={6} disabled={isEditing}>
      <Menu.Target>
        <ButtonComponent
          size="xSmall"
          label={isEditing ? 'Finish' : 'Add/Edit'}
          onClick={() => (isEditing ? onComplete() : null)}
        />
      </Menu.Target>

      <Menu.Dropdown
        className="--v2"
        styles={{
          dropdown: {
            background: 'transparent',
            border: 0,
          },
        }}
      >
        <div className="bg-white-primary rounded-8 p-6">
          <Menu.Item
            onClick={onCreate}
            leftSection={<PlusIcon className="text-14 text-tertirary" />}
          >
            <Text variation="small">Add Highlight</Text>
          </Menu.Item>
          <Menu.Item
            onClick={onEdit}
            leftSection={<EditIconPen className="text-14 text-tertirary" />}
          >
            <Text variation="small">Edit List</Text>
          </Menu.Item>
        </div>
      </Menu.Dropdown>
    </Menu>
  )
}
